module.exports = __webpack_public_path__ + "media/assets/fonts/fselliotpro-regular-webfont-9a31f9db85598fd023eee384c16d77bc.woff";